/**
 * Lower bound, in hours, of each "Time to Submit" bucket; the last is open-ended.
 * Sent as `time_to_submit_bucket_starts_hours`.
 */
export const HOUR_BUCKET_STARTS = [0, 6, 12, 18, 24, 36, 48] as const;

/**
 * How many groups the page's charts draw before folding the rest into one "Other".
 * Downloads are never folded, so the raw per-group numbers stay available.
 */
export const CHART_TOP_N = 5;
